import ActionTypes from './actionTypes';

function getMessageAction(type) {
  return function(content) {
    return {
      type,
      payload: content,
    };
  };
}

export const errorMessage = getMessageAction(ActionTypes.MESSAGE_ERROR);
export const warningMessage = getMessageAction(ActionTypes.MESSAGE_WARNING);
export const infoMessage = getMessageAction(ActionTypes.MESSAGE_INFO);
export const successMessage = getMessageAction(ActionTypes.MESSAGE_SUCCESS);
export const apiErrorsMessage = getMessageAction(ActionTypes.MESSAGE_API_ERRORS);

export function genericErrorMessage(err) {
  if (err instanceof Error) {
    return errorMessage(err.message);
  }
  return apiErrorsMessage(err);
}
